import { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router";
import { useAuth } from "@/state/auth";
import { rememberBrand } from "@/state/brand";
import { LogoLoader, PageSpinner } from "../ui/Feedback";
import { AskAgent } from "./AskAgent";
import { CommandPalette } from "./CommandPalette";
import { MobileNav, Rail } from "./Rail";
import { TasksDock } from "./TasksPanel";
import { TopBar } from "./TopBar";

export function AppShell() {
  const { isLoading } = useAuth();
  const [palette, setPalette] = useState(false);
  const { brandId } = useParams();
  const loc = useLocation();

  useEffect(() => rememberBrand(brandId), [brandId]);
  useEffect(() => {
    const h = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPalette((p) => !p);
      }
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, []);
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [loc.pathname]);

  if (isLoading) {
    return (
      <div className="grid h-full place-items-center bg-canvas">
        <LogoLoader />
      </div>
    );
  }

  return (
    <div className="flex min-h-full">
      <Rail onSearch={() => setPalette(true)} />
      <div className="flex min-w-0 flex-1 flex-col transition-[padding] duration-200 md:pl-[var(--rail-w)]">
        <TopBar />
        <main className="relative min-h-0 flex-1 pb-16 md:pb-0">
          <Suspense fallback={<PageSpinner />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <MobileNav onSearch={() => setPalette(true)} />
      <CommandPalette open={palette} onClose={() => setPalette(false)} />
      <AskAgent />
      <TasksDock />
    </div>
  );
}
